module.exports = __webpack_public_path__ + "static/img/pay-icon02.7d0ffa6c.svg";